export default "__VITE_ASSET__CVe7IenH__"